import { useRef } from "react";
import { classNames as cx } from "primereact/utils";
import { Menu } from "primereact/menu";
import { Button } from "primereact/button";

import { MessageType, RoomTypes } from "../../../../../../models/Chat";
import { getInitialsFromName } from "../../../../../../helpers/helperFunctions";
import moment from "moment";
import { useKeycloakContext } from "../../../../../../keycloak";

import classes from "./GroupItem.module.scss";

export interface IGroup {
  createdAt: string;
  createdBy: string;
  id: number;
  name: string;
  lastMessage?: {
    text: string;
    creator: {
      lastName: string;
      firstName: string;
    };
    createdAt: string;
    type: MessageType;
  };
  participantsNames: string;
  type: RoomTypes;
  role?: string;
  isSelected?: boolean;
  hasSeen?: boolean;
}

interface GroupItemProps extends IGroup {
  onGroupSelect: (id: number) => void;
  onGroupDelete: (id: number) => void;
}

export const GroupItem = ({
  name,
  lastMessage,
  createdAt,
  onGroupSelect,
  isSelected,
  type,
  participantsNames,
  id,
  createdBy,
  hasSeen,
  onGroupDelete,
}: GroupItemProps) => {
  const actionMenu = useRef<any>(null);

  const keycloakContext = useKeycloakContext();
  const subId = keycloakContext?.keycloak?.tokenParsed.sub;

  const actionItems = [
    // {
    //   label: "Archive",
    //   command: () => {
    //   },
    // },

    // {
    //   label: "Mark as unread",
    //   command: () => {},
    // },
    // {
    //   label: "Mute",
    //   command: () => {
    //   },
    // },
    ...(subId === createdBy
      ? [
          {
            label: "Delete",
            command: () => {
              onGroupDelete(id);
            },
          },
        ]
      : []),
  ];

  return (
    <div
      className={cx(classes.content, { [classes.selected]: isSelected })}
      onClick={() => !isSelected && onGroupSelect(id)}
    >
      <div className={classes.icon}>
        {type === RoomTypes.Group ? (
          <i className="pi pi-users" />
        ) : (
          <div className={classes.directIcon}>
            {getInitialsFromName(participantsNames)}
          </div>
        )}
      </div>
      <div className={classes.goupInfo}>
        <div className={classes.title}>
          {type === RoomTypes.Group ? name : participantsNames}
        </div>
        {type === RoomTypes.Group && (
          <div className={classes.participants}>{participantsNames}</div>
        )}
        {lastMessage && (
          <div
            className={cx(classes.recentMessage, {
              [classes.notSeen]: !hasSeen,
            })}
          >
            {lastMessage.creator.firstName} {lastMessage.creator.lastName}:{" "}
            {lastMessage.type === MessageType.Message
              ? lastMessage.text
              : "File"}
          </div>
        )}
      </div>
      <>
        <Menu model={actionItems} popup ref={actionMenu} id="popup_menu" />
        {actionItems.length ? (
          <Button
            icon="pi pi-ellipsis-v"
            //@ts-ignore
            onClick={(event) => {
              actionMenu.current && actionMenu.current.toggle(event);
            }}
            aria-controls="popup_menu"
            aria-haspopup
            className={cx(
              "p-button-rounded p-button-text",
              classes.actionButton
            )}
          />
        ) : null}
      </>
      <div className={classes.date}>
        {moment(lastMessage?.createdAt || createdAt).format("MM/DD/YYYY")}
      </div>
      {!hasSeen && <div className={classes.dot} />}
    </div>
  );
};
